class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.footerVisible = false
    this.setupListeners()

    if (this?.els?.current?.exists) {
      this.els.current.element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }

  setupListeners () {
    super.setupListeners()

    this.footerObserver = new IntersectionObserver(
      this.onFooterIntersect.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    )

    if (this.externalEls.footer.element) {
      this.footerObserver.observe(this.externalEls.footer.element)
    }
  }

  onFooterIntersect (entries) {
    entries.forEach((entry) => {
      // If any part of the footer is visible or we've scrolled past it
      if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
        this.footerVisible = true
      } else {
        this.footerVisible = false
      }

      if (this.footerVisible) {
        document.body.classList.remove(this.dataset.visibleClass)
      } else {
        document.body.classList.add(this.dataset.visibleClass)
      }
    })
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
